<template>
  <div class="main">
    <div class="main_top">
      <p>
        <el-select @change="handleChange1" placeholder="请选择模块" v-model="queryInfo.moduleid">
          <el-option
            v-for="item in options1"
            :key="item.itemid"
            :label="item.itemname"
            :value="item.itemid"
          >
          </el-option>
        </el-select>
        <el-select
          @change="handleChange2"
          style="margin-left:8px"
          placeholder="请选择分类"
          v-model="queryInfo.portaltype"
        >
          <el-option
            v-for="item in options2"
            :key="item.itemdetailid"
            :label="item.detailname"
            :value="item.itemdetailid"
          >
          </el-option>
        </el-select>
        <el-input placeholder="搜索文章" v-model="keyword" style="width:300px;margin-left:8px">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </p>

      <p>
        <el-button type="primary" icon="el-icon-plus" @click="modifyArtical()">
          新增
        </el-button>
      </p>
    </div>
    <div class="main_body">
      <el-table
        border
        ref="singleTable"
        :data="newDataList"
        highlight-current-row
        stripe
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" align="center" width="70px"> </el-table-column>
        <el-table-column prop="newstitle" label="文章标题" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column
          prop="portaltypename"
          label="文章分类"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column prop="author" label="作者" align="center" width="160px"> </el-table-column>
        <el-table-column prop="modifydate" label="修改时间" align="center" width="160px">
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center" width="160px">
          <el-input-number
            :min="0"
            style="width:120px"
            slot-scope="scope"
            v-model="scope.row.sort"
            @change="
              (value) => {
                sorthandleChange(value, scope.row)
              }
            "
          ></el-input-number>
        </el-table-column>
        <el-table-column prop="isshowgateway" label="状态" align="center" width="160px">
          <template slot-scope="scope">
            <el-switch
              @change="
                (value) => {
                  changeStatus(value, scope.row)
                }
              "
              v-model="scope.row.isshowgateway"
              :active-value="1"
              :inactive-value="0"
              active-text="发布"
            >
            </el-switch>
            <!-- <el-tag type="danger" v-if="scope.row.isshowgateway===0">未发布</el-tag>
            <el-tag type="primary" v-if="scope.row.isshowgateway===1">已发布</el-tag> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160px" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="success"
              style="margin-left:8px"
              icon="ios-create"
              @click="modifyArtical(scope.row.newsid)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              style="margin-left:8px"
              icon="md-trash"
              type="danger"
              @click="deluser(scope.row.newsid)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          style="text-align:center;margin-top:20px;"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryInfo.pagesize"
          :current-page="queryInfo.pageindex"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '../../../api'

export default {
  data() {
    return {
      newDataList: [],
      total: 1, //分页总条数
      evaNameList: [], //参数名称列表
      queryInfo: {
        portaltype: '',
        moduleid: '',
        keyword: '',
        pageindex: 1,
        pagesize: 10,
      },
      options1: [],
      options2: [],
      keyword: '',
      // 延时保存
      interval: 0,
    }
  },
  created() {
    this.GetDataList()
    this.getTree1()
  },
  watch: {
    queryInfo: {
      handler: function() {
        this.GetDataList()
      },
      deep: true,
    },
  },
  methods: {
    //用户表格选中项
    newChange(val) {
      this.newsItem = val
    },
    //获取文章列表
    async GetDataList() {
      const req = await Api.baseNewsinfo.GetPortalNewsList(this.queryInfo)
      if (req.success != true) return this.$Message.info(req.msg)
      this.newDataList = req.rows
      this.total = req.total
    },
    async getTree1() {
      const { rows } = await Api.dictionary.GetDataItemListByCode({ itemcode: 'PortalType' })
      this.options1 = [{ itemid: '', itemname: '全部' }, ...rows]
    },
    async getTree2(itemid) {
      const { rows } = await Api.dictionary.GetDataItemDetailTreeList(itemid)
      this.options2 = [{ itemdetailid: '', detailname: '全部' }, ...rows]
    },
    handleChange1(value) {
      this.getTree2(value)
      this.queryInfo.pageindex=1
      this.queryInfo.portaltype = ''
    },
    handleChange2(value) {
      this.queryInfo.pageindex=1
      this.queryInfo.portaltype = value
    },
    //搜索按钮
    search() {
      this.queryInfo.pageindex=1
      this.queryInfo.keyword = this.keyword
    },
    // 排序发生变化
    async sorthandleChange(value, item) {
      this.EditSort({ sort: value,newsId:item.newsid })
    },
    // 编辑文章
    modifyArtical(newsid) {
      if (newsid) {
        this.$router.push({ path: '/door/article/edit', query: { newsid: newsid } })
      } else {
        this.$router.push({ path: '/door/article/edit' })
      }
    },
    //删除文章
    async deluser(newsid) {
      this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await Api.baseNewsinfo.DelData([newsid])
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            location.reload()
          }
        })
        .catch(() => {})
    },
    handleCurrentChange(page) {
      this.queryInfo.pageindex = page
    },
    /**
     * 改变发布状态
     */
    async changeStatus(value, item) {
      this.IsShowPortal({ isShowGateway: value,newsId:item.newsid })
    },
    /**
     * 修改文章:状态
     */
    async IsShowPortal(value, item) {
      const res = await Api.baseNewsinfo.IsShowPortal(value)
        if (res.success) {
          this.$message({
            type: 'success',
            message: res.msg,
          })
        } else {
          this.$message.warning(res.msg)
        }
    },
    /**
     * 修改文章:排序
     */
    async EditSort(value, item) {
      const res = await Api.baseNewsinfo.EditSort(value)
        if (res.success) {
          this.$message({
            type: 'success',
            message: res.msg,
          })
        } else {
          this.$message.warning(res.msg)
        }
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px 40px;
  .main_top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    align-items: center;
  }
  /deep/ .el-input-number {
    line-height: 27px;
    .el-input__inner {
      line-height: 27px;
      height: 30px;
    }
  }
}
</style>
